import { render, staticRenderFns } from "./CouponCollapse.vue?vue&type=template&id=34bbf8ec&scoped=true&"
import script from "./CouponCollapse.vue?vue&type=script&lang=ts&"
export * from "./CouponCollapse.vue?vue&type=script&lang=ts&"
import style0 from "./CouponCollapse.vue?vue&type=style&index=0&id=34bbf8ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bbf8ec",
  null
  
)

export default component.exports